import type { DefaultTheme } from 'styled-components';

export interface RiskForecastLevelDisplay {
  label: string;
  color: string;
}

export const getRiskForecastLevelDisplay = (
  riskLevel: string | undefined,
  theme: DefaultTheme,
): RiskForecastLevelDisplay | null => {
  if (!riskLevel) {
    return null;
  }

  switch (riskLevel) {
    case 'danger':
      return { label: 'Dangerous', color: theme.colors.danger };
    case 'caution':
      return { label: 'Stay alert', color: theme.colors.success };
    case 'warning':
      return { label: 'Risky', color: theme.colors.warning };
    default:
      return { label: riskLevel, color: theme.colors.darkgrey };
  }
};
